import { Moment } from "moment";
import { LookupFields, UserFields } from "src/modules/modules.type";
import { LookUpRecord, UserRecord } from "src/types/main";
import { FIELDS_TYPES } from "./type.config";

export const myTaskMeetingsListName = "MyTaskMeetings";
export const myTaskCheckListsListName = "MyTaskCheckLists";
export const myTaskCheckListsForUserListName = "MTCheckListsForUser";
export const myTaskCheckListTasksListName = "MyTaskCheckListTasks";
export const myTaskCheckListCommentsListName = "MyTaskCheckListTasksComments";
export const myTaskCheckListCommentsFilesListName =
  "MyTaskCheckListTasksCommentsFiles";
export const myTaskCheckListResultsListName = "MyTaskCheckListResults";
export const myTaskCheckListDirectionsListName = "MyTaskCheckListDirection";
export const myTaskFrequenciesListName = "MyTaskFrequecies";
export const myTaskCheckListConnectionWithTasksListName = "MyTaskCheckListConnectionWithTasks";
export const myTaskShiftListName = "MTShift";

export const myTaskMeetingsListFields = {
  [myTaskMeetingsListName]: {
    ID: FIELDS_TYPES.ID,
    MOldId: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Status: FIELDS_TYPES.STRING,
    isPrivate: FIELDS_TYPES.BOOLEAN,
    Owners: FIELDS_TYPES.MULTI_STRING,
    Participants: FIELDS_TYPES.MULTI_STRING,
    Frequency: FIELDS_TYPES.STRING,
    Tor: FIELDS_TYPES.JSON,
    Created: FIELDS_TYPES.DATE,
    AdditionalFields: FIELDS_TYPES.JSON,
    Author: FIELDS_TYPES.USER,
  },
};

export type MyTaskMeetingsListFieldsRecordType = {
  [myTaskMeetingsListName]: {
    ID: number;
    MOldId: string;
    Title: string;
    Location: LookupFields;
    Department: LookupFields;
    Frequency: string;
    Tor: string;
    Status: string;
    isPrivate: boolean;
    Owners: string;
    Participants: string;
    Created: Date;
    AdditionalFields: string;
    Author: UserFields;
  };
};

export type MyTaskMeetingsListFieldsType = {
  [myTaskMeetingsListName]: {
    ID: number;
    MOldId: string;
    Title: string;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Frequency: string;
    Tor: string;
    Status: string;
    isPrivate: boolean;
    Owners: string;
    Participants: string;
    Created: Moment;
    AdditionalFields: string;
    Author: UserRecord;
  };
};

export const myTaskCheckListsFields = {
  [myTaskCheckListsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    UserPosition: FIELDS_TYPES.MULTI_STRING,
    ResponsibleEmail: FIELDS_TYPES.STRING,
  },
};

export const myTaskCheckListsForUserFields = {
  [myTaskCheckListsForUserListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    UserPosition: FIELDS_TYPES.MULTI_STRING,
    ResponsibleEmail: FIELDS_TYPES.STRING,
  },
};

export type MyTaskCheckListsFieldsRecordType = {
  [myTaskCheckListsListName]: {
    ID: number;
    Title: string;
    UserPosition: string;
    ResponsibleEmail: string;
  };
};

export type MyTaskCheckListsForUserFieldsRecordType = {
  [myTaskCheckListsForUserListName]: {
    ID: number;
    Title: string;
    UserPosition: string;
    ResponsibleEmail: string;
  };
};

export type MyTaskCheckListsFieldsType = {
  [myTaskCheckListsListName]: {
    ID: number;
    Title: string;
    UserPosition: string;
    ResponsibleEmail: string;
  };
};

export type MyTaskCheckListsForUserFieldsType = {
  [myTaskCheckListsForUserListName]: {
    ID: number;
    Title: string;
    UserPosition: string;
    ResponsibleEmail: string;
  };
};
export const myTaskCheckListTasksListFields = {
  [myTaskCheckListTasksListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Test: FIELDS_TYPES.STRING,
    Direction: FIELDS_TYPES.LOOKUP,
    Description: FIELDS_TYPES.STRING,
    CompletionCriteria: FIELDS_TYPES.STRING,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Editor: FIELDS_TYPES.USER,
    // Connections: FIELDS_TYPES.LOOKUP,
  },
};

export type MyTaskCheckListTasksListFieldsRecordType = {
  [myTaskCheckListTasksListName]: {
    ID: number;
    Title: string;
    Test: string;
    Direction: LookupFields;
    Description: string;
    CompletionCriteria: string;
    ResponsibleEmail: string;
    Author: UserFields;
    Editor: UserFields;
    // Connections: LookupFields;
  };
};

export type MyTaskCheckListTasksListFieldsType = {
  [myTaskCheckListTasksListName]: {
    ID: number;
    Title: string;
    Test: string;
    Direction: LookUpRecord;
    Description: string;
    CompletionCriteria: string;
    ResponsibleEmail: string;
    Author: UserRecord;
    Editor: UserRecord;
    // Connections: LookUpRecord;
  };
};

export const MyTaskCheckListConnectionWithTasksFields = {
  [myTaskCheckListConnectionWithTasksListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    CheckList: FIELDS_TYPES.LOOKUP,
    TaskPeriod: FIELDS_TYPES.STRING,
    Task: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    EndDate: FIELDS_TYPES.DATE,
    sort: FIELDS_TYPES.STRING,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Editor: FIELDS_TYPES.USER,
  },
};

export type MyTaskCheckListConnectionWithTasksFieldsRecordType = {
  [myTaskCheckListConnectionWithTasksListName]: {
    ID: number;
    Title: string;
    CheckList: LookupFields;
    TaskPeriod: string;
    Task: LookupFields;
    Created: Date;
    EndDate: Date;
    sort: string;
    ResponsibleEmail: string;
    Author: UserFields;
    Editor: UserFields;
  };
};

export type MyTaskCheckListConnectionWithTasksFieldsType = {
  [myTaskCheckListConnectionWithTasksListName]: {
    ID: number;
    Title: string;
    CheckList: LookUpRecord;
    TaskPeriod: string;
    Task: LookUpRecord;
    Created: Moment;
    EndDate: Moment;
    sort: string;
    ResponsibleEmail: string;
    Author: UserRecord;
    Editor: UserRecord;
  };
};

export const myTaskCheckListCommentsFields = {
  [myTaskCheckListCommentsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    TextComment: FIELDS_TYPES.STRING,
    Task: FIELDS_TYPES.LOOKUP,
    CreateCommentDate: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
  },
  [myTaskCheckListCommentsFilesListName]: {
    ID: FIELDS_TYPES.ID,
    Comment: FIELDS_TYPES.LOOKUP,
    ForHistory: FIELDS_TYPES.BOOLEAN,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
  },
};

export type MyTaskCheckListCommentsFieldsRecordType = {
  [myTaskCheckListCommentsListName]: {
    Title: string;
    ID: number;
    TextComment: string;
    Task: LookupFields;
    CreateCommentDate: Date;
    Created: Date;
    Author: UserFields;
  };
  [myTaskCheckListCommentsFilesListName]: {
    ID: number;
    Comment: LookupFields;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
};

export type MyTaskCheckListCommentsFieldsType = {
  [myTaskCheckListCommentsListName]: {
    Title: string;
    ID: number;
    TextComment: string;
    Task: LookUpRecord;
    CreateCommentDate: Moment;
    Created: Moment;
    Author: UserRecord;
  };
  [myTaskCheckListCommentsFilesListName]: {
    ID: number;
    Comment: LookUpRecord;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
};

export const myTaskCheckListResultsFields = {
  [myTaskCheckListResultsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    CheckList: FIELDS_TYPES.LOOKUP,
    Task: FIELDS_TYPES.LOOKUP,
    ConnectionID: FIELDS_TYPES.LOOKUP,
    TaskStatus: FIELDS_TYPES.STRING,
    TaskPeriod: FIELDS_TYPES.STRING,
    EmployeeEmail: FIELDS_TYPES.STRING,
    CompletedDate: FIELDS_TYPES.DATE,
    PeriodDate: FIELDS_TYPES.DATE,
    Test: FIELDS_TYPES.STRING,
  },
};

export type MyTaskCheckListResultsFieldsRecordType = {
  [myTaskCheckListResultsListName]: {
    ID: number;
    Title: string;
    CheckList: LookupFields;
    Task: LookupFields;
    ConnectionID: LookupFields;
    TaskStatus: string;
    TaskPeriod: string;
    EmployeeEmail: string;
    CompletedDate: Date;
    PeriodDate: Date;
    Test: string;
  };
};

export type MyTaskCheckListResultsFieldsType = {
  [myTaskCheckListResultsListName]: {
    ID: number;
    Title: string;
    CheckList: LookUpRecord;
    Task: LookUpRecord;
    ConnectionID: LookUpRecord;
    TaskStatus: string;
    TaskPeriod: string;
    EmployeeEmail: string;
    CompletedDate: Moment;
    PeriodDate: Moment;
    Test: string;
  };
};

export const myTaskCheckListDirectionsFields = {
  [myTaskCheckListDirectionsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
};

export type MyTaskCheckListDirectionsFieldsRecordType = {
  [myTaskCheckListDirectionsListName]: {
    ID: number;
    Title: string;
  };
};

export type MyTaskCheckListDirectionsFieldsType = {
  [myTaskCheckListDirectionsListName]: {
    ID: number;
    Title: string;
  };
};

export const myTaskCheckListFrequenciesFields = {
  [myTaskFrequenciesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
};

export type MyTaskCheckListFrequenciesFieldsRecordType = {
  [myTaskFrequenciesListName]: {
    ID: number;
    Title: string;
  };
};

export type MyTaskCheckListFrequenciesFieldsType = {
  [myTaskFrequenciesListName]: {
    ID: number;
    Title: string;
  };
};

export const myTaskShiftFields = {
  [myTaskShiftListName]: {
    ID: FIELDS_TYPES.ID,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    Date: FIELDS_TYPES.DATE,
    Comment: FIELDS_TYPES.STRING,
    Finished: FIELDS_TYPES.BOOLEAN,
  },
};

export type MyTaskShiftFieldsRecordType = {
  [myTaskShiftListName]: {
    ID: number;
    ResponsibleEmail: string;
    Date: string;
    Comment: string;
    Finished: boolean;
  };
};

export type MyTaskShiftFieldsType = {
  [myTaskShiftListName]: {
    ID: number;
    ResponsibleEmail: string;
    Date: string;
    Comment: string;
    Finished: boolean;
  };
};

export const myTaskMeetingsMainListFields = {
  ...myTaskMeetingsListFields,
  ...myTaskCheckListsFields,
  ...myTaskCheckListsForUserFields,
  ...myTaskCheckListTasksListFields,
  ...MyTaskCheckListConnectionWithTasksFields,
  ...myTaskCheckListCommentsFields,
  ...myTaskCheckListResultsFields,
  ...myTaskCheckListDirectionsFields,
  ...myTaskCheckListFrequenciesFields,
  ...myTaskShiftFields,
};

export type MyTaskMeetingsMainListFieldsRecordType = MyTaskMeetingsListFieldsRecordType &
  MyTaskCheckListsFieldsRecordType &
  MyTaskCheckListsForUserFieldsRecordType &
  MyTaskCheckListTasksListFieldsRecordType &
  MyTaskCheckListConnectionWithTasksFieldsRecordType &
  MyTaskCheckListCommentsFieldsRecordType &
  MyTaskCheckListResultsFieldsRecordType &
  MyTaskCheckListDirectionsFieldsRecordType &
  MyTaskCheckListFrequenciesFieldsRecordType &
  MyTaskShiftFieldsRecordType;

export type MyTaskMeetingsMainListFieldsType = MyTaskMeetingsListFieldsType &
  MyTaskCheckListsFieldsType &
  MyTaskCheckListsForUserFieldsType &
  MyTaskCheckListTasksListFieldsType &
  MyTaskCheckListConnectionWithTasksFieldsType &
  MyTaskCheckListCommentsFieldsType &
  MyTaskCheckListResultsFieldsType &
  MyTaskCheckListDirectionsFieldsType &
  MyTaskCheckListFrequenciesFieldsType &
  MyTaskShiftFieldsType;
